import { useQuery } from "@tanstack/react-query";

export function useGetDataServiceById({ callApiWithWorker, id, enabled }) {
  return useQuery({
    queryKey: ["dataServices", id],
    enabled: Boolean(enabled && id),
    queryFn: async ({ signal }) => {
      const res = await callApiWithWorker(`/dataservices/${id}`, {
        method: "GET",
        signal,
      });

      if (res?.body && typeof res.body === "string") {
        try {
          return JSON.parse(res.body);
        } catch {
          return res;
        }
      }

      return res?.data ?? res;
    },
    staleTime: 30_000,
  });
}
